export default [{
    id: '689c85c981bb447e8bdb718e6c2ad06f',
    desc: '专业检索账号',
    role_name: 'DB_SEARCH',
    display_name: 'DB_SEARCH',
    product: 'pro',
}, {
    id: 'ac433ef1c1e94fd9972abc794171edc6',
    desc: '专业分析账号',
    role_name: 'DB_AYS',
    display_name: 'DB_AYS',
    product: 'pro',
}, {
    id: 'e2f94e85931046ab994e242b83c2c8a2',
    desc: '超级账号',
    role_name: 'DB_SUPER',
    display_name: 'DB_SUPER',
    product: 'pro',
}, {
    id: 'd77bd12ed12c4a2297492b17b8752ef2',
    desc: '试用账号',
    role_name: 'DB_TRIAL',
    display_name: 'DB_TRIAL',
    product: 'pro',
}, {
    id: '305e7fbb5b3248c1bfb318406ab0ae6d',
    desc: '专业检索账号分析升级包',
    role_name: 'ADD_SEARCH',
    display_name: 'ADD_SEARCH',
    product: 'pro',
}, {
    id: 'b2e2b7cd36db496baa9478e71597b715',
    desc: '工作空间升级包',
    role_name: 'ADD_WORKSPACE',
    display_name: 'ADD_WORKSPACE',
    product: 'pro',
}, {
    id: '907eb993218748fda9749c8a7c1fde5c',
    desc: '工作空间升级包100K',
    role_name: 'ADD_WORKSPACE100K',
    display_name: 'ADD_WORKSPACE100K',
    product: 'pro',
    // }, {
    //     TODO 暂时删除
    //     id: '47c084883f794dfab578ed3fdc009990',
    //     desc: '高级分析BI版',
    //     role_name: 'ADD_BIAYS',
    //     display_name: 'ADD_BIAYS',
    //     product: 'pro'
}, {
    id: 'dc3a37ffb5fb46388b973b2a330f2b49',
    desc: '单独专利文献权限，需要叠加其他权限使用',
    role_name: 'NPL',
    display_name: 'ADD_NPL',
    product: 'pro',
}, {
    id: '0cbd8583e90143509d4c6d8ecd5f21dc',
    desc: '专业分析账号升级包-Insights',
    role_name: 'INSIGHTS',
    display_name: 'INSIGHTS',
    product: 'report',
}, {
    id: 'c507fa9924ec435d93c3310047ea04f3',
    desc: 'Insights试用账号',
    role_name: 'INSIGHTS_TRIAL',
    display_name: 'INSIGHTS_TRIAL',
    product: 'report',
}, {
    id: '404917dd269044afaf3536f485e8a48b',
    desc: '专业分析账号升级包-BI Insights',
    role_name: 'BI_INSIGHTS',
    display_name: 'BI_INSIGHTS',
    product: 'report',
}, {
    id: '562a8b38ca3544ca9893626dbae1d52b',
    desc: '搜索子账号',
    role_name: 'SUB_SEARCH',
    display_name: 'SUB_SEARCH',
    product: 'pro',
}, {
    id: '0abb86f9ae5f4a73b49ef765d7977f13',
    desc: '协作子账号',
    role_name: 'SUB_WORKSPACE',
    display_name: 'SUB_WORKSPACE',
    product: 'pro',
}, {
    id: '03d7e0f2046a4e7fbc5aef2ede09cab6',
    desc: '特殊IP匿名权限',
    role_name: 'IP_GUEST',
    display_name: 'IP_GUEST',
    product: 'pro',
}, {
    id: '2d341d7be1b64a2cbef58e6412266b74',
    desc: '基础版',
    role_name: 'SME Basic',
    display_name: 'SME Basic',
    product: 'pro',
}, {
    id: '56bb4bf9035d42d6b7f6b8367af952a6',
    desc: 'Workspace',
    role_name: 'Workspace (discard)',
    display_name: 'Workspace only for SME',
    product: 'pro',
}, {
    id: '37f34922a4bc4d37a4624ebc80a1d0a0',
    desc: '2019中国化学数据库权限',
    role_name: 'Chemical CN',
    display_name: 'Chemical CN',
    product: 'chemical',
}, {
    id: 'bb09759e041d461183a9f48af57fe222',
    desc: 'Chemical Pre-release role',
    role_name: 'Chemical Pre-release',
    display_name: 'Chemical Pre-release',
    product: 'chemical',
}, {
    id: '16dc48b699534d84b9a812c2ed0e073d',
    desc: 'Basic role for BioScience',
    role_name: 'Bio Basic',
    display_name: 'Bio Basic',
    product: '563398857b284d14a48575e06990b9e4',
}, {
    id: 'ea82e3967cf74cf4aa16472bf71c5252',
    desc: 'Bio Pre-release Role',
    role_name: 'Bio Pre-release',
    display_name: 'Bio Pre-release',
    product: '563398857b284d14a48575e06990b9e4',
}]
